"use client";

interface HeaderProps {
    title: string;
    subtitle?: string;
    actions?: React.ReactNode;
}

export default function Header({ title, subtitle, actions }: HeaderProps) {
    return (
        <header className="header" id="app-header">
            <div>
                <h1 className="header-title">{title}</h1>
                {subtitle && (
                    <p style={{ fontSize: "var(--text-xs)", color: "var(--text-tertiary)", marginTop: "2px" }}>
                        {subtitle}
                    </p>
                )}
            </div>
            {actions && <div className="header-actions">{actions}</div>}
        </header>
    );
}
